<template>
  <section class="sec-explain">
    <div class="float-bg" />
    <div class="explain-wrapper">
      <div class="explain-main">{{ explainDesc }}</div>
      <div class="explain-btn-wrapper">
        <div class="common-btn" @click="goRouterCooperate" v-rseat="'click_carnival_cooperate'">商务合作</div>
        <div class="common-btn" @click="jumpGghz" v-rseat="'click_carnival_gghz'">广告合作</div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    explainDesc: {
      type: String,
      default: () => '',
    },
  },
  methods: {
    goRouterCooperate() {
      this.$router.push(
        {
          name: 'carnival2020-cooperate',
        },
        () => {
          document.body.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        },
      )
    },
    jumpGghz() {
      window.open('https://www.iqiyi.com/marketing/m.gghz.html')
    },
  },
}
</script>
<style lang="less">
.sec-explain {
  position: relative;
  width: 100%;
  height: 906px;
  &::after {
    position: absolute;
    top: -40px;
    left: 0;
    display: block;
    content: '';
    width: 100%;
    height: 946px;
    background: transparent url('~@/assets/carnival2020/explain_bg.png') center center no-repeat;
    background-size: 1920px auto;
  }

  .float-bg {
    left: -130px;
    top: -195px;
    width: 637px;
    height: 298px;
    transform: rotate(150deg);
  }

  .explain-wrapper {
    position: relative;
    top: 86px;
    z-index: 2;
    width: 1102px;
    margin: 0 auto;
    padding-top: 187px;
  }

  .explain-main {
    height: 286px;
    overflow: hidden;
    font-size: 20px;
    line-height: 35px;
    color: #ffffff;
    margin-bottom: 102px;
    padding: 44px 44px 46px 43px;
  }

  .explain-btn-wrapper {
    font-size: 0;
    text-align: center;
    .common-btn {
      padding: 20px 82px;
      font-size: 36px;
      font-weight: 750;
      box-shadow: -10px -10px #7741fe;
      cursor: pointer;
      &:first-child {
        margin-right: 90px;
      }
    }
  }
}
</style>
